import { render, staticRenderFns } from "./UserWelcome.vue?vue&type=template&id=c8d754bc&scoped=true"
import script from "./UserWelcome.vue?vue&type=script&lang=js"
export * from "./UserWelcome.vue?vue&type=script&lang=js"
import style0 from "./UserWelcome.vue?vue&type=style&index=0&id=c8d754bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d754bc",
  null
  
)

export default component.exports